<template>
  <!-- tenantid is marked as required, but we don't have a tenant for now. it is used when redirecting to info page. 
   let's use a dummy id since it doesn't currently break anything, and to make sure tenantid is no accidentally not defined elsewhere-->
  <layout tenantId="unknowntenant" :loginInfo="loginInfo">
    <h1>{{ $t('LoginError.HeaderText') }}</h1>
    <p>{{ $t(errorMessage) }}</p>
  </layout>
</template>

<script setup lang="ts">

import layout from './layout.vue';

import { ref, computed } from 'vue';
import type LoginInfo from '@/loginInfo';
const loginInfo = ref({ displayName: '', authMethods: '' } as LoginInfo);

const reason = new URLSearchParams(window.location.search).get('reason');
const errorMessage = computed(() => {
  // the reason is not used for now, but we can use it to display different messages based on the reason
  // check SamlController for different reason codes
  // if(reason === 'acsget') {
  //   return 'LoginError.Acsget';
  // }
  // if(reason === 'acspost') {
  //   return 'LoginError.Acspost';
  // }
  return 'LoginError.DefaultReason';
});
</script>
<style src="./sign2.css" />
